(() => {
  if (window.porchetProfessionalReturnReady) return;
  window.porchetProfessionalReturnReady = true;

  // Capture the current variant at activation, including after a variant change.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-professional-product-return]');
    if (!link) return;
    const destination = new URL(link.href);
    destination.searchParams.set('return_to', window.location.pathname + window.location.search);
    link.href = destination.href;
  });

  const returnTo = new URLSearchParams(window.location.search).get('return_to');
  if (!returnTo || !returnTo.startsWith('/') || returnTo.startsWith('//')) return;
  const destination = new URL(returnTo, window.location.origin);
  // Only accept local product pages, never arbitrary redirect destinations.
  if (destination.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections\/[^/]+\/)?products\/[^/]+\/?$/i.test(destination.pathname)) return;

  document.querySelectorAll('a[data-professional-sign-in]').forEach((link) => {
    const login = new URL(link.href, window.location.origin);
    login.searchParams.set('return_to', destination.pathname + destination.search);
    link.href = login.href;
  });
})();
